import dayjs from "dayjs";

import { swSettings } from "app/common/services/swSettings";

import { formatDuration } from "../../../../activation-alerts/utils/formatDuration";

export const getDurationForPriorityAlertDate = (alertDate: string): string | undefined => {
    const parsed = dayjs(alertDate);

    if (!parsed.isValid()) {
        return;
    }

    const from = parsed.startOf("day");
    const to = from.add(6, "day");
    const duration = formatDuration({ from, to });

    if (swSettings.allowedDuration(duration, "Alerts")) {
        return duration;
    }

    return;
};
